import { motion } from "framer-motion";

interface Props {
  image: string;
  caption?: string;
  color?: string;
}

const IndustryLifecycle = ({ image, caption }: Props) => {
  return (
    <section className="py-16 sm:py-24 bg-secondary/30">
      <div className="container mx-auto px-6 lg:px-10 max-w-5xl">
        {caption && (
          <div className="mb-8">
            <div className="flex items-center gap-3 mb-2">
              <span className="w-6 h-0.5 rounded-full bg-primary" />
              <p className="text-xs font-medium text-muted-foreground uppercase tracking-wider">Development to Delivery</p>
            </div>
            <h2 className="text-xl sm:text-2xl font-bold text-foreground mb-2">Product lifecycle</h2>
            <p className="text-sm text-muted-foreground max-w-2xl">{caption}</p>
          </div>
        )}
        <motion.div
          className="rounded-xl overflow-hidden bg-background"
          initial={{ opacity: 0, y: 20 }}
          whileInView={{ opacity: 1, y: 0 }}
          viewport={{ once: true }}
          transition={{ duration: 0.5 }}
        >
          <img
            src={image}
            alt="Product lifecycle diagram"
            className="w-full h-auto"
            loading="lazy"
          />
        </motion.div>
      </div>
    </section>
  );
};

export default IndustryLifecycle;
